export default function checkPasswordStrength (input: any) {
  let score = 0;
  if (!input) {
    return score;
  }

  let hasLetters = /[a-z]/i.test(input);
  let hasNumbers = /[0-9]/.test(input);
  if (hasLetters && hasNumbers) {
    score += 0.5;
  }

  let hasBothCases = /[a-z]/.test(input) && /[A-Z]/.test(input);
  if (hasBothCases) {
    score += 0.5;
  }


  if (input.length > 20) {
    score += 1.5;
  }
  else if (input.length > 15) {
    score += 1.25;
  }
  else if (input.length > 11) {
    score += 1
  }
  else if (input.length > 7) {
    score += 0.5;
  }
  else if (input.length > 3) {
    score += 0.25;
  }

  let hasSpecial = /[^a-z0-9]/i.test(input);
  if (hasSpecial) {
    score += 0.5;
  }

  let hasReallySpecial = /[^a-z0-9\-\_\+\.]/i.test(input)
  if (hasReallySpecial) {
    score += 1;
  }

  if (!hasLetters) {
    return score;
  }

  let doesNotRepeat = true;
  for (let i = 0; i < input.length; i++) {
    if (i == 0) {
      continue;
    }
    if (input[i] === input[i - 1]) {
      doesNotRepeat = false;
      break;
    }
  }
  if (doesNotRepeat) {
    score += 0.5;
  }

  let isNotPatterned = true;
  let last2 = "";
  let next2 = "";
  if (input.length > 7) {
    for (let i = 0; i < input.length; i++) {
      if (i < 1) {
        continue;
      }

      last2 = input.substring(i - 2, i);
      next2 = input.substring(i, i + 2);

      if (last2 === next2) {
        isNotPatterned = false;
        break;
      }
    }
    if (isNotPatterned) {
      score += 0.5;
    }
  }


  return score;
}
